import React from 'react';
import { css } from '@linaria/core';
import classNames from 'classnames';
import { CheckIcon } from '@bambuser-ui/icons/index.js';

const checkboxClassnames = {
  root: css`
    position: relative;
    display: flex;
    margin-bottom: 8px;
  `,
  checkbox: css`
    position: absolute;
    width: 20px;
    height: 20px;
    cursor: pointer;
    opacity: 0;
    margin: 0;
  `,
  rightCheckbox: css`
    flex-direction: row-reverse;
  `,
  checkmark: css`
    position: absolute;
    top: 0;
    width: 20px;
    height: 20px;
    border: 1px solid black;
    background-color: white;
    cursor: pointer;
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  leftCheckmark: css`
    left: 0;
  `,
  rightCheckmark: css`
    right: 0;
  `,
  checkmarkChecked: css`
    background-color: black;
  `,
  labelOnRight: css`
    margin-left: 28px;
    font-size: 14px;
    align-self: center;
    cursor: pointer;
  `,
  labelOnLeft: css`
    margin-right: 28px;
    font-size: 14px;
    align-self: center;
    cursor: pointer;
  `,
  disabled: css`
    opacity: 0.5;
    cursor: not-allowed;
  `,
};

const Checkbox = ({
  id,
  label = '',
  checked = false,
  style: overwriteStyles = {},
  disabled,
  onMouseEnter,
  onMouseLeave,
  labelStyle,
  checkmarkPosition = 'left',
  checkmarkStyle,
  checkboxStyle,
  ...attr
}) => {
  const uniqueName = id || Math.random().toString();
  const labelClass = classNames(checkmarkPosition === 'left' ? checkboxClassnames.labelOnRight : checkboxClassnames.labelOnLeft, { [checkboxClassnames.disabled]: disabled });
  const _label = typeof label === 'string' ? <label htmlFor={uniqueName} style={labelStyle} className={labelClass}>{label}</label> : label(uniqueName);
  const checkmarkClasses = classNames(checkboxClassnames.checkmark, checkboxClassnames[`${checkmarkPosition}Checkmark`], { [checkboxClassnames.checkmarkChecked]: checked });

  return (
    <div
      className={classNames(checkboxClassnames.root, checkboxClassnames[`${checkmarkPosition}Checkbox`], { [checkboxClassnames.disabled]: disabled })}
      style={{ ...overwriteStyles }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <input id={uniqueName} className={classNames(checkboxClassnames.checkbox, { [checkboxClassnames.disabled]: disabled })} type="checkbox" disabled={disabled} defaultChecked={checked} style={checkboxStyle} {...attr} />
      <div style={checkmarkStyle} className={checkmarkClasses}>
        {checked && <CheckIcon type="small" color="white" style={{ marginRight: 1 }} />}
      </div>
      {_label && _label}
    </div>
  );
};
export default Checkbox;
